var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFinancialHigh5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 115,
    height: 115,
    viewBox: "0 0 115 115",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11.311 54.718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.792,33.9a57.5,57.5,0,1,1-57.5-57.5,57.5,57.5,0,0,1,57.5,57.5",
    transform: "translate(58.519 -31.114)",
    fill: "#2d9f52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.749,11.122H3.153L-1.3-3.628S-2.115-6.6,1.786-7.471c.321-.073,4.486-.672,6.514,2.728h.3a4.8,4.8,0,0,1,4.719-3.005c.575,0,3.94.153,4.987,2.92h.356s2.1-3.979,7.357-2.6C26.469-7.308,29-6.178,28.34-3.58,28.274-3.324,23.749,11.122,23.749,11.122ZM43.7,36.786c0-10.4-7.812-19.12-18.407-21.691H1.857c-10.6,2.572-18.405,11.3-18.405,21.691,0,9.883,7.055,18.255,16.849,21.273H26.847C36.641,55.041,43.7,46.668,43.7,36.786Z",
    transform: "translate(55.236 -22.372)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,13.9l3.47-1.557a4.613,4.613,0,0,0,1.545,2.476A5.506,5.506,0,0,0,7.9,15.9V7.42A15.394,15.394,0,0,1,2.425,4,6.276,6.276,0,0,1,.716-.392,6.593,6.593,0,0,1,2.625-5.254,8.781,8.781,0,0,1,7.9-7.594V-9.67H9.826v2.115a9.568,9.568,0,0,1,4.318,1.318,5.9,5.9,0,0,1,2.405,2.988L13.172-1.543a5.422,5.422,0,0,0-1.435-1.55,4.819,4.819,0,0,0-1.911-.77V3.6q4.5,2.131,6.044,3.877A6.281,6.281,0,0,1,17.415,11.8a7.549,7.549,0,0,1-1.974,5.427,8.994,8.994,0,0,1-5.615,2.515V22.9H7.9V19.817a9.73,9.73,0,0,1-5.254-1.708A7.141,7.141,0,0,1,0,13.9M7.9-3.751A3.966,3.966,0,0,0,5.949-2.61a2.973,2.973,0,0,0-.6,1.94,3.4,3.4,0,0,0,.6,2A5.612,5.612,0,0,0,7.9,2.91Zm1.928,19.54a4.257,4.257,0,0,0,2.3-1.345,3.625,3.625,0,0,0,.787-2.383,3.3,3.3,0,0,0-.734-2.135A6.932,6.932,0,0,0,9.826,8.217Z",
    transform: "translate(59.531 7.263)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancialHigh5);
export default __webpack_public_path__ + "static/media/financial-high-5.5befaeec173124dcbe4bc52ceead6290.svg";
export { ForwardRef as ReactComponent };